export default "__VITE_ASSET__LP$OjPHe__"